<template>
  <v-data-table
    :headers="headers"
    :items="userSignatures"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="ListUserSignature-button-new"
          :to="{
            name: 'processing-EditUserSignature'
          }"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.userId="{ item }">
      {{ getEmailById(item.userId) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'processing-EditUserSignature',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListUserSignature',
  module: 'Signatures',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapGetters('userManagement', ['getEmailById']),
    ...mapState('userManagement', ['users']),
    ...mapState('userSignatures', ['userSignatures', 'userSignature']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('reportName'),
          value: 'reportName',
        },
        {
          text: this.$$t('userId'),
          value: 'userId',
        },
        {
          text: this.$$t('role'),
          value: 'role',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_userSignatures();
    await this.loadUsers();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('userSignatures', ['LOAD_userSignatures', 'DELETE_userSignature']),
    ...mapActions('userManagement', ['loadUsers']),
    /** Delete UserSignature from the collection
     */
    async remove(userSignature) {
      this.isLoading = true;
      await this.DELETE_userSignature(userSignature);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# FormSignature example

'''js
<FormSignature />
'''
</docs>
